export const createQuotePackageSchema = {
  initialValues: {
    name: '',
    description: '',
    package_type: 'custom',
    is_active: true,
  },
  validationRules: {
    name: {
      required: true,
      minLength: 3,
      message: 'Το όνομα είναι υποχρεωτικό (τουλάχιστον 3 χαρακτήρες)',
    },
  },
  sections: [
    {
      title: 'Βασικά Στοιχεία',
      fields: [
        {
          name: 'name',
          label: 'Όνομα Πακέτου',
          type: 'text',
          required: true,
          size: 8,
        },
        {
          name: 'package_type',
          label: 'Τύπος Πακέτου',
          type: 'select',
          size: 4,
          options: [
            { value: 'development', label: 'Ανάπτυξη' },
            { value: 'hosting', label: 'Hosting' },
            { value: 'saas', label: 'SaaS' },
            { value: 'maintenance', label: 'Συντήρηση' },
            { value: 'custom', label: 'Custom' },
          ],
        },
        {
          name: 'description',
          label: 'Περιγραφή',
          type: 'text',
          multiline: true,
          rows: 3,
          size: 12,
        },
        {
          name: 'is_active',
          label: 'Ενεργό Πακέτο',
          type: 'checkbox',
          size: 4,
        },
      ],
    },
  ],
};

export const updateQuotePackageSchema = {
  ...createQuotePackageSchema,
};

